export default "__VITE_PUBLIC_ASSET__53183ad3__"